export const DEFAULT_PRODUCT_HANDLE = process.env.REACT_APP_DEFAULT_PRODUCT_HANDLE || 'pfas-test-dev';

const app_co = process.env.REACT_APP_COMPANY;

export const defaultSiteTitle = app_co === 'frost' ? 'FROST' : 'Relentless Health';
